export enum BalanceSheetsRoute {
  empty = '',
  resultAllocation = 'result-allocation',
  immobilisations = 'immobilisations',
  loan = 'loan',
  stocks = 'stocks',
  odBilan = 'od-bilan',
  fiscalResults = 'fiscal-results',
  vatFramework = 'vat-framework',
  caFramework = 'ca-framework',
  tns = 'tns',
  leaseContracts = 'lease-contracts',
  suppliers = 'suppliers',
  accountInterests = 'account-interests'
}
